<template>
  <Dialog
    v-model="dialogValue"
    v-bind="$attrs"
    :persistent="true"
  >
    <template #content>
      <div :class="{ 'mb-4': hasDeletionCheck }">
        {{ message }}
      </div>
      <div v-if="hasDeletionCheck">
        <div>
          {{ $t("Please type {deleteSecurityWord} to confirm.", { deleteSecurityWord: $t("deleteSecurityWord") }) }}
        </div>
        <InputText
          v-model="deleteConfirmation"
          class="col-6 px-0"
          :rules="[ rules.deletioncheck ]"
        />
        <small>
          {{ $t("* Some of your data will be kept temporarily before deletion.") }}
        </small>
      </div>
    </template>

    <template #actions>
      <Button
        color="secondary"
        @click="cancel"
      >
        {{ $t(cancelText) }}
      </Button>
      <Button
        v-if="hasDeletionCheck"
        :disabled="!deletionCheck"
        color="error"
        @click="confirmDeletion"
      >
        {{ $t(confirmText) }}
      </Button>
      <Button
        v-else
        :color="deleteButton ? 'error' : 'primary'"
        @click="confirm"
      >
        {{ $t(confirmText) }}
      </Button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
import Dialog from "@/components/dialogs/Dialog.vue";
import Button from "@/components/input-components/Button.vue";
import InputText from "@/components/input-components/InputText.vue";
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const props = defineProps({
  modelValue: { type: Boolean, required: true },
  message: { type: String, default: "" },
  deleteButton: { type: Boolean, default: false },
  confirmText: { type: String, default: "Ok" },
  cancelText: { type: String, default: "Cancel" },
  hasDeletionCheck: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue", "confirm", "cancel"]);

const deleteConfirmation = ref("");

const dialogValue = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

const rules = {
  deletioncheck: (value: string) =>
    (t("deleteSecurityWord") as string) === value,
};

const deletionCheck = computed(
  () => (t("deleteSecurityWord") as string) === deleteConfirmation.value
);

function cancel() {
  deleteConfirmation.value = "";
  emit("update:modelValue", false);
  emit("cancel");
}

function confirm() {
  deleteConfirmation.value = "";
  emit("update:modelValue", false);
  emit("confirm");
}

function confirmDeletion() {
  if (deletionCheck.value) confirm();
}
</script>
